import {Component, Input, OnInit, Inject} from 'ng-metadata/core';
import {ChaptersAndReviewsItemService} from './chaptersAndReviewsItem.service';
import {SeedData} from './chaptersAndReviews.directive';
import {PrimoResponse} from "../../infra/dataStructures/PrimoResponses/doc.interfcae";
import {SearchStateService} from "../searchState.service";
import {SearchService} from "../search.service";
import {ChaptersAndReviewsService} from "./chaptersAndReviews.service";
import {TemplateUtil} from "../../nddUtils/templateUtil.service";
import {FullViewDialogService} from "../fullView/fullViewDialog.service";
import {getVid} from "../../appConfig/appConfigForward";


const Subject= require('rxjs/Subject').Subject;
const Observable= require('rxjs/Observable').Observable;
require('rxjs/add/observable/fromPromise');
const get= require('lodash/get');

@Component({
    selector: 'prm-chapters-and-Reviews-item',
    templateUrl: 'components/search/chaptersAndReviews/chapters-and-reviews-item.html',
})

export class PrmChaptersAndReviewsItem implements OnInit{
    // @Input() public seed : SeedData;
    private _deepLinkPath: string;
    private getItemPromise: angular.IPromise;
    @Input() public item: Object ;
    private promiseObservable: Subject<any>;
    private GET_ITEM_API_URL: string;
    private vid = getVid();

    constructor(@Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') restBaseURLs,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private chaptersAndReviewsItemService: ChaptersAndReviewsItemService,
                private searchStateService: SearchStateService,
                private chaptersAndReviewsService: ChaptersAndReviewsService,
                @Inject('$state') private $state: angular.ui.IStateService,
                private searchService: SearchService,
                private templateUtil: TemplateUtil,
                private fullViewDialogService: FullViewDialogService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService) {

        this.GET_ITEM_API_URL= restBaseURLs.pnxBaseURL;
    }



    ngOnInit() {
    }

     get title(){
        return get(this.item,'pnx.display.title[0]');
    }

    get resourceType() {
        return 'mediatype.' + get(this.item, 'pnx.display.type[0]');
    }

    get contributor() {
        return get(this.item,'pnx.display.contributor[0]') || '';
    }

    get creator(){
            return get(this.item,'pnx.display.creator[0]') || '';
    }

    get creatorAndContributor() {
        return this.getTextFromVal(this.creator) + (this.creator ? ' ' :'') + this.getTextFromVal(this.contributor);
    }

    get deepLinkPath(){
        if(this.item){
            return this.templateUtil.getFullDeepLinkAbsPath(this.item);
        }
    }

    private openFullView($event){
        if (this.item){
            this.fullViewDialogService.openFullViewDialog(this.item, $event, 'chaptersAndReviewsItem');
        }
        else {
            this.getItemPromise.then(()=>{
                this.fullViewDialogService.openFullViewDialog(this.item, $event, 'chaptersAndReviewsItem');
            });
        }
    }

    public onItemClick($event){
        $event.preventDefault(); //do not open the href
            this.openFullView($event);
            return;
    }
    
    public getTextFromVal(value) {
        return (value && value.includes('$$Q')) ? value.split('$$Q')[0] : value; //text
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/chaptersAndReviews/chaptersAndReviewsItem.directive.ts